import {
  Button,
  Input,
  Label,
  Alert,
  AlertDescription,
} from '@suscri/ui';
import { Shield, Lock, AlertCircle } from 'lucide-react';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { AuthShell } from '../components/AuthShell';
import { trpc } from '../lib/trpc';

export function AdminLoginPage() {
  // Modo individual (cuenta con rol ADMIN/SUPPORT) o contraseña maestra legacy
  const [mode, setMode] = useState<'account' | 'master'>('account');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const adminLoginMutation = trpc.admin.login.useMutation();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    try {
      const result = await adminLoginMutation.mutateAsync(
        mode === 'account' ? { email, password } : { password }
      );
      localStorage.setItem('adminToken', result.token);
      localStorage.setItem('adminRole', result.adminRole);
      navigate('/admin');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error de autenticación');
    }
  };

  return (
    <AuthShell
      compact
      title="Acceso de Administrador"
      subtitle={mode === 'account'
        ? 'Entra con tu cuenta (necesita rol de administración)'
        : 'Introduce la contraseña maestra de administrador'}
    >
        <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-xl border border-primary/20 bg-primary/15 text-primary">
          <Shield className="h-6 w-6" />
        </div>

        <div className="flex rounded-xl border border-border bg-background/40 p-1 text-sm">
          <button
            type="button"
            onClick={() => setMode('account')}
            className={`flex-1 rounded-lg px-3 py-2 font-medium transition-colors ${
              mode === 'account'
                ? 'bg-primary text-primary-foreground shadow-sm'
                : 'text-muted-foreground hover:bg-accent hover:text-foreground'
            }`}
          >
            Con mi cuenta
          </button>
          <button
            type="button"
            onClick={() => setMode('master')}
            className={`flex-1 rounded-lg px-3 py-2 font-medium transition-colors ${
              mode === 'master'
                ? 'bg-primary text-primary-foreground shadow-sm'
                : 'text-muted-foreground hover:bg-accent hover:text-foreground'
            }`}
          >
            Contraseña maestra
          </button>
        </div>

        <form className="mt-6 space-y-5" onSubmit={handleLogin}>
          {mode === 'account' && (
            <div>
              <Label htmlFor="email" className="mb-2 block">Email</Label>
              <Input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="tu@email.com"
              />
            </div>
          )}
          <div>
            <Label htmlFor="password" className="mb-2 block">Contraseña</Label>
            <Input
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              required
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder={
                mode === 'account'
                  ? 'Contraseña de tu cuenta'
                  : 'Contraseña de administrador'
              }
            />
          </div>
          {error && (
            <Alert variant="destructive">
              <AlertCircle className="h-4 w-4" />
              <AlertDescription>{error}</AlertDescription>
            </Alert>
          )}
          <div>
            <Button type="submit" className="w-full" size="lg" disabled={adminLoginMutation.isPending}>
              <Lock className="h-4 w-4" aria-hidden="true" />
              {adminLoginMutation.isPending
                ? 'Iniciando sesión...'
                : 'Iniciar Sesión'}
            </Button>
          </div>
        </form>
    </AuthShell>
  );
}
